import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { ChefHat, Users, Star, Calendar } from "lucide-react";

const features = [
  { icon: ChefHat, titleKey: "home.features.masterChefs", descKey: "home.features.masterChefsDesc" },
  { icon: Users, titleKey: "home.features.anyEventSize", descKey: "home.features.anyEventSizeDesc" },
  { icon: Star, titleKey: "home.features.premiumQuality", descKey: "home.features.premiumQualityDesc" },
  { icon: Calendar, titleKey: "home.features.flexibleService", descKey: "home.features.flexibleServiceDesc" },
];

const FeaturesSection = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="features-section"
      className="py-20 md:py-32 bg-[#F4F1DE] pattern-bg"
      ref={sectionRef}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="section-header reveal">
          <span className="text-[#E07A5F] font-medium tracking-wider uppercase text-sm">
            {t("home.features.badge")}
          </span>
          <h2 className="mt-3">{t("home.features.title")}</h2>
          <p>{t("home.features.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <Card
              key={feature.titleKey}
              className="reveal bg-white/80 backdrop-blur border-[#E07A5F]/10 card-lift"
              data-testid={`feature-card-${feature.titleKey}`}
            >
              <CardContent className="p-8 text-center">
                <div className="feature-icon-wrap w-16 h-16 bg-[#E07A5F]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <feature.icon className="w-8 h-8 text-[#E07A5F]" />
                </div>
                <h3 className="text-xl font-semibold text-[#3D405B] mb-3">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-[#6B705C]">{t(feature.descKey)}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
